import axios from 'axios'

const initial = {
  token() {
    return localStorage.getItem('token') || ''
  },
  user() {
    return {}
  },
  permissions() {
    return []
  },
  status() {
    return ''
  },
}

const state = {
  token: initial.token(),
  user: initial.user(),
  permissions: initial.permissions(),
  status: initial.status(),
}

const mutations = {
  AUTH_REQUEST(state) {
    state.status = 'loading'
  },
  AUTH_SUCCESS(state, { token, user, permissions }) {
    state.token = token
    state.user = user
    state.permissions = permissions
    state.status = 'success'
  },
  AUTH_USER(state, { user, permissions }) {
    state.user = user
    state.permissions = permissions
  },
  AUTH_ERROR(state) {
    state.token = ''
    state.status = 'error'
  },
  AUTH_LOGOUT(state) {
    state.status = ''
    state.token = ''
  },
}

const actions = {
  getUser({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('auth/user')
        .then((response) => {
          const user = response.data.user

          const permissions = []
          // store just the permission names, no need for any other data at the moment
          for (let i in response.data.user_permissions) {
            permissions.push(response.data.user_permissions[i].name)
          }

          commit('AUTH_USER', { user, permissions })
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      axios
        .post('auth/login', { email: user.email, password: user.password })
        .then(response => {
          const user = response.data.user
          const token = 'Bearer ' + response.data.access_token
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = token

          const permissions = []
          // store just the permission names, no need for any other data at the moment
          for (let i in response.data.user_permissions) {
            permissions.push(response.data.user_permissions[i].name)
          }
          commit('AUTH_SUCCESS', { token, user, permissions })
          resolve()
        })
        .catch(err => {
          commit('AUTH_ERROR')
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('AUTH_LOGOUT')
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
}

const getters = {
  token: state => state.token,
  user: state => state.user,
  permissions: state => state.permissions,
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  isAdmin: state => !state.user.roles ? false : state.user.roles.filter(r => r.name === 'admin').length,
  hasPermission: state => permission => {
    if (!state.permissions.length) {
      return false
    }
    return state.permissions.indexOf(permission) !== -1
  },
  hasAllPermissions: state => permissions => {
    if (!state.permissions.length) {
      return false
    }
    for (let i in permissions) {
      if (state.permissions.indexOf(permissions[i]) === -1) {
        return false
      }
    }
    return true
  },
  hasAnyOfPermissions: state => permissions => {
    if (!state.permissions.length) {
      return false
    }
    for (let i in permissions) {
      if (state.permissions.indexOf(permissions[i]) !== -1) {
        return true
      }
    }
    return false
  },
  hasPermissionRoot: state => root => {
    if (!state.permissions.length) {
      return false
    }
    return state.permissions.some(p => p.indexOf(root) !== -1)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
